








import { Component, Vue } from "vue-property-decorator";
import BookingSummaryDetail from "@/components/booking/BookingSummaryDetail.vue";

@Component({
  components: {
    BookingSummaryDetail
  }
})
export default class BookingSummary extends Vue {}
